module.exports = __WEBPACK_EXTERNAL_MODULE_72__;


//////////////////
// WEBPACK FOOTER
// external "u2f-api-polyfill"
// module id = 72
// module chunks = 0